import { Component, Inject, ViewEncapsulation, OnDestroy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef }
	from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { MatRadioModule } from '@angular/material/radio';
import { NgFor } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { pageTransitions } from '../../animations/page-transitions';
import { User } from '../../models/user';
import { UserService } from '../../services/user.service';
import { TranslationService } from '../../services/translation.service';
import { SURVEY_SCREEN_NAME_OPTIONS } from '../../models/list';

import { UserSurveyAnswerDialogData } from './user-survey-answer-dialog-data';

@Component({
	selector: 'copo-survey-answer-dialog',
	templateUrl: './survey-answer-dialog.component.html',
	styleUrl: './survey-answer-dialog.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [

		MatButtonModule,
		MatIconModule,
		TranslateModule,
		NgFor,

		MatRadioModule,
		FormsModule,
		ReactiveFormsModule,
		MatDialogModule
	]
})
export class SurveyAnswerDialogComponent implements OnDestroy {
	scores: number[] = [1, 2, 3, 4, 5, 6, 7];
	user: User;
	saveSub?: Subscription;
	screenCode: keyof typeof SURVEY_SCREEN_NAME_OPTIONS;
	screenUrl: string;
	easyToFindScoreControl = new FormControl();
	timeAmountScoreControl = new FormControl();
	clarityScoreControl = new FormControl();

	constructor(
		private readonly userService: UserService,

		private readonly dialogRef: MatDialogRef<SurveyAnswerDialogComponent>,
		private readonly translationService: TranslationService,

		private readonly snackBar: MatSnackBar,

		@Inject(MAT_DIALOG_DATA) public data: UserSurveyAnswerDialogData,
	) {
		this.user = this.userService.user;
		this.screenCode = this.data.screenCode;
		this.screenUrl = this.data.screenUrl;
	}

	ngOnDestroy() {
		if (this.saveSub) {
			this.saveSub.unsubscribe();
		}
	}

	cancelOnClick() {
		this.dialogRef.close('cancel');
	}

	getSurveyScreenCodeTr(screenCode: keyof typeof SURVEY_SCREEN_NAME_OPTIONS) {
		return SURVEY_SCREEN_NAME_OPTIONS[screenCode];
	}

	surveyScoresControl() {
		return <number> this.easyToFindScoreControl.value
			&& <number> this.clarityScoreControl.value
			&& <number> this.timeAmountScoreControl.value;
	}

	surveyAnswer() {
		const surveyAnswer: UserSurveyAnswerDialogData = {
			easyToFindScore: <number> this.easyToFindScoreControl.value,
			timeAmountScore: <number> this.timeAmountScoreControl.value,
			clarityScore: <number> this.clarityScoreControl.value,
			screenCode: this.screenCode,
			screenUrl: this.screenUrl
		};

		this.saveSub = this.userService.saveUserSurvey(surveyAnswer).subscribe({
			next: async () => {
				await this.userService.updateSurvey(this.screenCode, true);
				this.dialogRef.close();
				this.snackBar.open(
					this.translationService.getTR(
						'snackbar.survey'
					),
					undefined,
					{
						duration: 2000,
					}
				);
			},
			error: (error: unknown) => {
				console.error(error);
			}
		});
	}
}
